import { MouseEvent } from "react";
import clsx from "clsx";
import Icon, { IconGlyph, IconSize } from "../icon/Icon";
import IconSpinner from "../icon/IconSpinner";
import { ColorVariant } from "../typography/Typography";
import styles from "./iconButton.module.scss";

export type IconButtonSize = "sm" | "md";
export type IconButtonVariant = "plain" | "surface" | "scrim" | "tertiary";

interface Props {
  icon: IconGlyph;
  label: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  size?: IconButtonSize;
  iconSize?: IconSize;
  variant?: IconButtonVariant;
  color?: ColorVariant;
  loading?: boolean;
  className?: string;
}

export default function IconButton({
  icon,
  label,
  onClick,
  size = "md",
  iconSize = "xl",
  variant = "plain",
  color,
  loading = false,
  className,
}: Props) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-busy={loading || undefined}
      disabled={loading}
      onClick={onClick}
      className={clsx(styles.button, styles[size], variant !== "plain" && styles[variant], className)}
    >
      {loading ? <IconSpinner size={iconSize} color={color} /> : <Icon icon={icon} size={iconSize} color={color} />}
    </button>
  );
}
